import { EntityType } from 'api'
import { useSelector } from 'react-redux'
import { currentOrganisationSelector } from 'selectors/adminSelectors'
import { isCurrentOrganisationBuySideSelector, isCurrentOrganisationSellSideSelector } from 'selectors/organisationSelectors'
import { createAllEntitiesHook, createEntityGetterHook, createEntityHook } from './common'
import { createReferenceDataEntityHook } from './referenceData'

export const useOrganisation = createEntityHook(EntityType.ORGANISATION)
export const useAllOrganisations = createAllEntitiesHook(EntityType.ORGANISATION)
export const useOrganisationGetter = createEntityGetterHook(EntityType.ORGANISATION)
export const useOrganisationReferenceData = createReferenceDataEntityHook(EntityType.ORGANISATION)

export const useIsCurrentOrganisationBuySide = () => useSelector(isCurrentOrganisationBuySideSelector)
export const useIsCurrentOrganisationSellSide = () => useSelector(isCurrentOrganisationSellSideSelector)
export const useCurrentOrganisation = () => useSelector(currentOrganisationSelector)
